import React, { useState, useEffect } from 'react';
import axios from 'axios';
import PageHeader from '../../components/common/PageHeader/PageHeader';
import EditPopup from '../../components/Popup/EditPopup/EditPopup'; 
import AddPopup from '../../components/Popup/AddPopup/AddPopup';
import ArchivePopup from '../../components/Popup/ArchivePopup/ArchivePopup';
import EditIcon from '../../components/Table/EditIcon/EditIcon';
import ArchiveIcon from '../../components/Table/ArchiveIcon/ArchiveIcon';
import ExportLabel from '../../components/common/ExportLabel/Export';
import DownloadLabel from '../../components/common/DownloadLabel/Download';
import AddButton from '../../components/common/AddButton/AddButton';
import SearchBox from '../../components/common/Search/SearchBox';
import Filter from '../../components/common/Filter/Filter';
import Sort from '../../components/common/Sort/Sort';
import DateFilter from '../../components/common/DateFilter/DateFilter';
import './BasicExchangeHistory.css';
import { baseurl } from '../../api';
import SimpleSearchBox from '../../components/common/Search/SimpleSearch';
import authenticatedAxios from '../../authenticatedAxios';
import { useCheckboxClick } from '../../checkboxclick';

// const BasicExchangeHistory = () => {

//   return (
//     <div className='whole-container'>
//       <div className='top-heading'>
//         {/* <PageHeader pageName="Localization/Currencies/Basic exchange history" /> */}
//         <PageHeader pageName="Localization/Currencies" nestedpageName="Basic exchange history"  linkTo="/currencies" /> 
//         <div className='export-container'>
//           <DownloadLabel />
//           <ExportLabel />
//         </div>
//       </div>
//       <div className='pagename-container'>
//         <div className='page-name'>
//           <h1 className='common-text fts-18 ftw-5 black'>Basic Exchange History</h1>
//         </div>
//         <div className='pagename-right-container'>
//           <AddButton onClick={handleNewClick} />
//           <SimpleSearchBox placeholder="Search language" onSearchSelect={handleSearchSelect} />
//           <button className='left-arrow-button arrow-button'>
//             <svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
//               <path d="M25.3125 2.52591L18.5566 2.52594V0.843948C18.5566 0.377667 18.179 0 17.7128 0C17.2467 0 16.8691 0.377667 16.8691 0.843948V2.52551H10.1191V0.843948C10.1191 0.377667 9.74152 0 9.27534 0C8.80917 0 8.43159 0.377667 8.43159 0.843948V2.52551H1.6875C0.755578 2.52551 0 3.28127 0 4.21341V25.3121C0 26.2442 0.755578 27 1.6875 27H25.3125C26.2444 27 27 26.2442 27 25.3121V4.21341C27 3.28166 26.2444 2.52591 25.3125 2.52591ZM25.3125 25.3121H1.6875V4.21341H8.43159V5.06369C8.43159 5.52994 8.80917 5.90763 9.27534 5.90763C9.74152 5.90763 10.1191 5.52994 10.1191 5.06369V4.21383H16.8691V5.06411C16.8691 5.53039 17.2467 5.90806 17.7128 5.90806C18.179 5.90806 18.5566 5.53039 18.5566 5.06411V4.21383H25.3125V25.3121ZM19.4062 13.4972H21.0938C21.5595 13.4972 21.9375 13.1191 21.9375 12.6533V10.9654C21.9375 10.4995 21.5595 10.1214 21.0938 10.1214H19.4062C18.9405 10.1214 18.5625 10.4995 18.5625 10.9654V12.6533C18.5625 13.1191 18.9405 13.4972 19.4062 13.4972ZM19.4062 20.2484H21.0938C21.5595 20.2484 21.9375 19.8707 21.9375 19.4044V17.7165C21.9375 17.2507 21.5595 16.8726 21.0938 16.8726H19.4062C18.9405 16.8726 18.5625 17.2507 18.5625 17.7165V19.4044C18.5625 19.8711 18.9405 20.2484 19.4062 20.2484ZM14.3438 16.8726H12.6562C12.1905 16.8726 11.8125 17.2507 11.8125 17.7165V19.4044C11.8125 19.8707 12.1905 20.2484 12.6562 20.2484H14.3438C14.8095 20.2484 15.1875 19.8707 15.1875 19.4044V17.7165C15.1875 17.2511 14.8095 16.8726 14.3438 16.8726ZM14.3438 10.1214H12.6562C12.1905 10.1214 11.8125 10.4995 11.8125 10.9654V12.6533C11.8125 13.1191 12.1905 13.4972 12.6562 13.4972H14.3438C14.8095 13.4972 15.1875 13.1191 15.1875 12.6533V10.9654C15.1875 10.4991 14.8095 10.1214 14.3438 10.1214ZM7.59375 10.1214H5.90625C5.4405 10.1214 5.0625 10.4995 5.0625 10.9654V12.6533C5.0625 13.1191 5.4405 13.4972 5.90625 13.4972H7.59375C8.0595 13.4972 8.4375 13.1191 8.4375 12.6533V10.9654C8.4375 10.4991 8.0595 10.1214 7.59375 10.1214ZM7.59375 16.8726H5.90625C5.4405 16.8726 5.0625 17.2507 5.0625 17.7165V19.4044C5.0625 19.8707 5.4405 20.2484 5.90625 20.2484H7.59375C8.0595 20.2484 8.4375 19.8707 8.4375 19.4044V17.7165C8.4375 17.2511 8.0595 16.8726 7.59375 16.8726Z" fill="#424242"/>
//             </svg>
//           </button>
//           <button className='left-arrow-button arrow-button'>
//             <svg width="17" height="14" viewBox="0 0 17 14" fill="none" xmlns="http://www.w3.org/2000/svg">
//               <path d="M0.207736 6.50478L6.58253 0.205129C6.71544 0.0737877 6.8957 7.03281e-08 7.08366 8.676e-08C7.27162 1.03192e-07 7.45188 0.0737878 7.58479 0.205129C7.7177 0.33647 7.79236 0.514607 7.79236 0.700351C7.79236 0.886096 7.7177 1.06423 7.58479 1.19557L2.41855 6.30004L16.2917 6.30004C16.4795 6.30004 16.6597 6.37379 16.7925 6.50505C16.9254 6.63632 17 6.81436 17 7C17 7.18564 16.9254 7.36368 16.7925 7.49495C16.6597 7.62622 16.4795 7.69996 16.2917 7.69996L2.41855 7.69996L7.58479 12.8044C7.71769 12.9358 7.79236 13.1139 7.79236 13.2996C7.79236 13.4854 7.71769 13.6635 7.58479 13.7949C7.45188 13.9262 7.27162 14 7.08366 14C6.8957 14 6.71543 13.9262 6.58253 13.7949L0.207736 7.49522C0.141879 7.43021 0.0896345 7.35302 0.05399 7.26804C0.0183436 7.18307 -1.30343e-06 7.09199 -1.29539e-06 7C-1.28735e-06 6.90801 0.0183436 6.81693 0.05399 6.73196C0.0896346 6.64698 0.141879 6.56978 0.207736 6.50478Z" fill="#424242"/>
//             </svg>
//           </button>
//           <DateFilter options={datefilterOptions} />
//           <button className='right-arrow-button arrow-button'>
//             <svg width="17" height="14" viewBox="0 0 17 14" fill="none" xmlns="http://www.w3.org/2000/svg">
//               <path d="M16.7923 7.49522L10.4175 13.7949C10.2846 13.9262 10.1043 14 9.91634 14C9.72838 14 9.54812 13.9262 9.41521 13.7949C9.2823 13.6635 9.20764 13.4854 9.20764 13.2996C9.20764 13.1139 9.2823 12.9358 9.41521 12.8044L14.5814 7.69996H0.70831C0.520455 7.69996 0.340293 7.62621 0.207459 7.49495C0.0746255 7.36368 0 7.18564 0 7C0 6.81436 0.0746255 6.63632 0.207459 6.50505C0.340293 6.37378 0.520455 6.30004 0.70831 6.30004H14.5814L9.41521 1.19557C9.2823 1.06423 9.20764 0.886095 9.20764 0.70035C9.20764 0.514606 9.2823 0.336469 9.41521 0.205128C9.54812 0.0737866 9.72838 0 9.91634 0C10.1043 0 10.2846 0.0737866 10.4175 0.205128L16.7923 6.50478C16.8581 6.56978 16.9104 6.64698 16.946 6.73196C16.9817 6.81693 17 6.90801 17 7C17 7.09198 16.9817 7.18307 16.946 7.26804C16.9104 7.35302 16.8581 7.43021 16.7923 7.49522Z" fill="#424242"/>
//             </svg>
//           </button>
//           <span className='common-text dk-gray fts-15 '>2024-August</span>
//         </div>
//       </div>

//       <div className='table-container'>
//         <table className='common-table'>
//           <thead className='common-table-head '>
//             <tr className='common-table-thead-tr basic-exchange-tr'>
//               <th className='basic-exchange-tr'>Date</th>
//               <th>Basic Exchange Rate</th>
//             </tr>
//           </thead>
//           <tbody className="common-table-tbody">
//             {items.map((item, index) => (
//               <tr key={index}>
//                 <td className="basic-exchange-tr">{item.date_time}</td>
//                 <td className="basic-rate-td">
//                   <span>1 {item.currency.name} = {item.dollar_exchange_rate} $</span>
//                   {item.is_high ? (
//                     <svg className="is_high" width="11" height="12" viewBox="0 0 11 12" fill="none" xmlns="http://www.w3.org/2000/svg">
//                       <path d="M4.36647 11.3806L4.36647 2.82632L1.044 6.1488L0 5.1048L5.1048 0L10.2096 5.1048L9.16561 6.1488L5.84313 2.82632L5.84313 11.3806H4.36647Z" fill="#148F00" />
//                     </svg>
//                   ) : (
//                     <svg className="is_low" width="11" height="12" viewBox="0 0 11 12" fill="none" xmlns="http://www.w3.org/2000/svg">
//                       <path d="M5.843 2.44138e-05L5.843 8.55429L9.16548 5.23182L10.2095 6.27581L5.10467 11.3806L-0.0001283 6.27581L1.04387 5.23182L4.36634 8.55429L4.36634 2.42847e-05L5.843 2.44138e-05Z" fill="#BD3D44" />
//                     </svg>
//                   )}
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>

//             <AddPopup/>
//            <EditPopup/>
//     </div>
//   );
// };

// export default BasicExchangeHistory;


const BasicExchangeHistory = () => {
    const [items, setItems] = useState([]);
    const [currencies, setCurrencies] = useState([]);
    const [searchParams, setSearchParams] = useState({ term: '' });
    const [currencyOptions, setCurrencyOptions] = useState([]);
    const [isPopupVisible, setIsPopupVisible] = useState(false);
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [selectedExchangeHistory, setSelectedExchangeHistory] = useState(null);
    const [selectedItem, setSelectedItem] = useState(null);
    const [isFilterApplied, setIsFilterApplied] = useState(false);

    
    const [isLoading, setIsLoading] = useState(true);



    const fetchExchangeHistories = async (id = null) => {
        try {
            if (id) {
                const response = await authenticatedAxios.get(`${baseurl}currency/exchange-history/?id=${id}`);
                if (response && response.data) {
                    setSelectedExchangeHistory(response.data.data);
                }
            } else {
                const params = {
                    search: searchParams.term,
                };

                const response = await authenticatedAxios.get(`${baseurl}currency/exchange-history/`, { params });
                setItems(response.data?.data || []);
            }
        } catch (error) {
            console.error('Error fetching exchange histories:', error);
            setItems([]);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchExchangeHistories();
    }, [searchParams]);

    const handleSearchSelect = (term) => {
        setSearchParams({ term });
    };

    const togglePopup = () => {
        setIsPopupVisible(!isPopupVisible);
    };
    const formatDate = (dateString) => {
        if (!dateString) return '-';
        const date = new Date(dateString);
        return date.toLocaleDateString('en-GB', {
            day: 'numeric',
            month: 'short',
            year: 'numeric',
        }).replace(/ /g, '-');
    };
    

    const fetchExchangeHistoriesWithFilters = async (params = {}) => {
        try {
          const response = await authenticatedAxios.get(
            `${baseurl}currency/exchange-history/`,
            { params }
          );
          setItems(response.data?.data || []);
        } catch (error) {
          console.error('Error fetching exchange histories:', error);
          setItems([]);
        } finally {
          setIsLoading(false);
        }
      };
      
      const applyFilters = () => {
        const params = {
            search: searchParams.term,
            start_date: startDate,
            end_date: endDate,
        };
        fetchExchangeHistoriesWithFilters(params);
        setIsFilterApplied(true);
    };
    
    const clearFilters = () => {
        setStartDate('');
        setEndDate('');
        setSearchParams({ term: '' });
        setIsFilterApplied(false);
    };

    if (isLoading) {
        return <div>Loading...</div>;
    }

  return (
      <div className='whole-container'>
          <div className='top-heading'>
              <PageHeader 
                  pageName="Localization/Currencies" 
                  nestedpageName="Base Exchange History"  
                  linkTo="/currencies" 
              /> 
              <div className='export-container'>
                  <DownloadLabel />
                  <ExportLabel />
              </div>
          </div>
          <div className='pagename-container'>
              <div className='page-name'>
                  <h1 className='common-text fts-18 ftw-5 black'>Base Exchange History</h1>
              </div>
              <div className='pagename-right-container'>
              {isFilterApplied && (
                    <>
                        <span className='common-text fts-14 ftw-4 black'>From Date :</span>
                        <span className='common-text fts-14 ftw-4 black'>{formatDate(startDate)}</span>

                        <span className='common-text fts-14 ftw-4 black' style={{ marginLeft: '20px' }}>To Date :</span>
                        <span className='common-text fts-14 ftw-4 black'>{formatDate(endDate)}</span>
                    </>
                )}

                <div className='date-filter-container'>
                    <button 
                        className={`all-date common-text fts-15 lt-gray ${isPopupVisible ? 'active' : ''}`} 
                        onClick={togglePopup}
                    >
                        <span>Date Filter </span>
                        <span 
                            className={`filter-dropdown-icon fts-12 ${isPopupVisible ? 'rotated' : ''}`}
                        >
                            ▼
                        </span>
                    </button>
                    {isPopupVisible && (
                        <div className="date-filter-popup">
                            <div className="datelabel-input">
                                <label className="fts-13 lt-gray common-text">From:</label>
                                <input
                                    type="date"
                                    className="date-input lt-gray"
                                    value={startDate}
                                    onChange={(e) => setStartDate(e.target.value)}
                                />
                            </div>
                            <div className="datelabel-input">
                                <label className="fts-13 lt-gray common-text">To:</label>
                                <input
                                    type="date"
                                    className="date-input lt-gray"
                                    value={endDate}
                                    onChange={(e) => setEndDate(e.target.value)}
                                />
                            </div>
                            <div className="date-filter-buttons">
                                <button className="bg-blue white" onClick={applyFilters}>
                                    Apply
                                </button>
                                <button onClick={clearFilters}>Clear</button>
                            </div>
                        </div>
                    )}
                </div>
            </div>

          </div>

            {/* Your page header and search components */}
            <div className="table-container">
                <table className="common-table">
                    <thead className="common-table-head">
                        <tr className="common-table-thead-tr input-less-tr">
                            <th>Date</th>
                            <th>Base Exchange History</th>
                        </tr>
                    </thead>
                    <tbody className="common-table-tbody">
                        {items.map((item) => (
                            <tr key={item.id} className='input-less-tr'>
                                <td>{formatDate(item.date_time)}</td>
                                <td>
                                    1 {item.currency_name} = {item.dollar_exchange_rate} $
                                    {item.is_high ? (
                                    <svg className="is_high" width="11" height="12" viewBox="0 0 11 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M4.36647 11.3806L4.36647 2.82632L1.044 6.1488L0 5.1048L5.1048 0L10.2096 5.1048L9.16561 6.1488L5.84313 2.82632L5.84313 11.3806H4.36647Z" fill="#148F00" />
                                    </svg>
                                    ) : (
                                    <svg className="is_low" width="11" height="12" viewBox="0 0 11 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M5.843 2.44138e-05L5.843 8.55429L9.16548 5.23182L10.2095 6.27581L5.10467 11.3806L-0.0001283 6.27581L1.04387 5.23182L4.36634 8.55429L4.36634 2.42847e-05L5.843 2.44138e-05Z" fill="#BD3D44" />
                                    </svg>
                                    )}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
      </div>
  );
};

export default BasicExchangeHistory;